//Action creator with callback function
export function addCountryCodes(countrycodes) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_COUNTRY_CODES',
                payload: countrycodes
            });
            resolve(true)
        });
    }
};

export const resetCountryCodes = () => ({
    type: 'RESET_COUNTRY_CODES'
});